{
  "page": {
    "heading": "Notifications",
    "unreadBadge": "{{count}} non lues"
  },
  "categories": {
    "all": "Toutes",
    "orders": "Commandes",
    "products": "Produits",
    "stores": "Boutiques",
    "vendors": "Fournisseurs",
    "billing": "Facturation",
    "system": "Système"
  },
  "filters": {
    "ariaLabel": "Filtrer les notifications par catégorie",
    "unreadOnly": "Non lues uniquement"
  },
  "actions": {
    "markAllRead": "Tout marquer comme lu",
    "markRead": "Marquer comme lu",
    "dismiss": "Ignorer",
    "openDetail": "Ouvrir les détails",
    "loadMore": "Charger plus",
    "loadingMore": "Chargement…"
  },
  "list": {
    "ariaLabel": "Fil de notifications"
  },
  "loading": "Chargement des notifications…",
  "empty": {
    "body": "Aucune notification."
  },
  "errors": {
    "load": "Échec du chargement des notifications",
    "loadMore": "Échec du chargement de plus de notifications",
    "markRead": "Échec de la mise à jour",
    "dismiss": "Échec du rejet de la notification",
    "markAllRead": "Échec du marquage de tout comme lu"
  }
}